import actions from './actions';

const {
  ADD_ACC_BEGIN,
  ADD_ACC_SUCCESS,
  ADD_ACC_ERR,

  GET_ACC_BEGIN,
  GET_ACC_SUCCESS,
  GET_ACC_ERR,

  UPDATE_ACC_BEGIN,
  UPDATE_ACC_SUCCESS,
  UPDATE_ACC_ERR,

  DELETE_ACC_BEGIN,
  DELETE_ACC_SUCCESS,
  DELETE_ACC_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const AccountantReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADD_ACC_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADD_ACC_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case ADD_ACC_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case GET_ACC_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_ACC_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_ACC_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_ACC_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_ACC_SUCCESS:
      return {
        ...state,
        error: false,
        data,
        loading: false,
      };

    case DELETE_ACC_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_ACC_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_ACC_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case UPDATE_ACC_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { AccountantReducer };
